import React from "react";

function HeaderAbout() {
  return (
    <div>
      <header className="header-about">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center mt-5 wow animate__animated animate__fadeInDown">
              <h3 className="text-white">شركة سوفت تريد للصناعات الغذائية</h3>
              <h6 className="text-white">
                مصنع ومصدر بطاطس شيبسي بجودة عالمية
              </h6>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default HeaderAbout;
